const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

class Tooltip extends React.Component {
  static get propTypes() {
    return {
      title: PropTypes.string.isRequired,
      powerTipOptions: PropTypes.object,
      className: PropTypes.string,
      children: PropTypes.node,
    };
  }

  componentDidMount() {
    $(this.refs.tooltip).powerTip(this.powerTipOptions);
  }

  get powerTipOptions() {
    return Object.assign({
      smartPlacement: true,
      mouseOnToPopup: true,
    }, (this.props.powerTipOptions || {}));
  }

  contents() {
    if (this.props.children) {
      return this.props.children;
    }

    return <i className="fa fa-question-circle" />;
  }

  render() {
    return (
      <span
        className={classNames(['tooltip', this.props.className])}
        ref="tooltip"
        title={this.props.title}
      >
        {this.contents()}
      </span>
    );
  }
}

module.exports = Tooltip;



// WEBPACK FOOTER //
// ./javascripts/components/tooltip.jsx